import styles from './divider.module.scss';
import MaterialDivider from '@mui/material/Divider';

/* eslint-disable-next-line */
export interface DividerProps {
  // absolute?: boolean,
  children?: any,
  // classes?: object,
  component?: any,
  flexItem?: boolean,
  light?: boolean,
  orientation?: 'horizontal' | 'vertical',
  // sx?: any,
  textAlign?: 'center' | 'left' | 'right',
  variant?: 'fullWidth' | 'inset' | 'middle',
  className?: string,
  sx?: any
}

export function Divider(props: DividerProps) {
  return (
    <MaterialDivider
      variant={props.variant}
      orientation={props.orientation}
      className={`${props.className} ${styles.GreyDivider}`}
      flexItem={props.flexItem}
      component={props.component}
      textAlign={props.textAlign}
      sx={props.sx}
      light={props.light}>
      {props.children}
    </MaterialDivider>
  );
}

export default Divider;